import * as React from 'react'

import { Button } from '@/shared/ui/primitives'
import { cn } from '@/shared/ui/cn'

type ErrorStateProps = {
  title: string
  description?: string
  onRetry?: () => void
  retryLabel?: string
  className?: string
}

function ErrorState({
  title,
  description,
  onRetry,
  retryLabel = 'Retry',
  className,
}: ErrorStateProps) {
  return (
    <div
      data-slot="error-state"
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-md border border-destructive/40 bg-destructive/10 px-6 py-10 text-center text-destructive',
        className,
      )}
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      {description ? (
        <p className="text-sm text-destructive/80">{description}</p>
      ) : null}
      {onRetry ? (
        <div data-slot="error-state-action" className="pt-2">
          <Button type="button" variant="destructive" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export { ErrorState }
export type { ErrorStateProps }
